module.exports = __webpack_public_path__ + "img/noFavoriteillustration.5b5448af.svg";